import { useTranslation } from "react-i18next";
import defaultContent from "../../../../../content/earningsCalculator";
import { IconAdd } from "../../../../../common/icons/IconAdd/IconAdd";
import LeafLinkButton from "../../../../../common/leaf/LeafLinkButton/LeafLinkButton";
import "./EarningsCalculatorAddABOLegTile.scss";

type Props = {
  IsLoading: boolean;
  Onclick: () => void;
};

const EarningsCalculatorAddABOLegTile = ({ IsLoading, Onclick }: Props) => {
  const { t } = useTranslation(["earningsCalculator"]);

  if (IsLoading) return <></>;

  return (
    <div className="earnings-calculator-add-abo-leg-tile">
      <LeafLinkButton
        theme="blue"
        fontWeight="bold"
        underlined
        onClick={Onclick}
        as="link"
        label={`${t("aboLegs.legTile.addAboLeg", defaultContent["aboLegs"]["legTile"]["addAboLeg"])}`}
      >
        <IconAdd color="blue" />
        {t("aboLegs.legTile.addAboLeg", defaultContent["aboLegs"]["legTile"]["addAboLeg"])}
      </LeafLinkButton>
    </div>
  );
};

export default EarningsCalculatorAddABOLegTile;
